import withLayout from '../../hoc/with-layout';
import { TakingAssingmentController } from './taking-assingment.controller';
import { TakingAssingmentProps } from './taking-assingment.model';

const TakingAssingment = (props: TakingAssingmentProps) => {
  return <TakingAssingmentController {...props} />;
};

export default withLayout(TakingAssingment);
